export default __webpack_public_path__ + "cover_gold.261f0555.png";